import React from "react";

import { PageProps } from "src/pages/Router/routes";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import {
  TabbedNavigation,
  TabOptions
} from "src/library/components/TabbedNavigation";
import Grid from "src/library/components/Hedron";
import {
  categorisedProcessJobs,
  filterHelper,
  filterOutSuperAdminJobs,
  optionsHelper,
  processJobCategories,
  ProcessJobCategories,
  titleHelper
} from "src/core/process-job/components/processJobTableUtils";
import ProcessJobsQueueTable from "src/core/process-job/components/ProcessJobsTable";
import { useCurrentUser } from "src/core/users/hooks";

const ProcessJobsQueuePage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const { terminology } = props;
  const [ { currentRole } ] = useCurrentUser();

  const tabs: TabOptions[] = React.useMemo(() => {
    const processedTabs = processJobCategories.map((category: keyof ProcessJobCategories) => {
      const title = titleHelper(category);
      let tabJobNames = categorisedProcessJobs[ category ];

      //if the user is not super admin filter out those jobs
      if (currentRole?.code !== "super-admin") {
        tabJobNames = filterOutSuperAdminJobs(tabJobNames);
      }

      const tab: TabOptions = {
        title,
        content: () => {
          return (
            <ProcessJobsQueueTable
              tableName={title}
              specificFilters={filterHelper(tabJobNames)}
              nameHeaderFilterOptions={optionsHelper(tabJobNames)}
              terminology={terminology}
            />
          );
        }
      };

      return tab;
    }

    );

    return processedTabs;
  }, [ terminology, currentRole ]);

  return (
    <Layout {...props}>
      <MainContentWrapper fill>
        <Grid.Bounds direction="vertical">
          <TabbedNavigation
            className="tab-navigator"
            tabs={tabs}
            defaultTab="Main Jobs"
          />
        </Grid.Bounds>
      </MainContentWrapper>
    </Layout>
  );
};

export default ProcessJobsQueuePage;
